<main class="block pt-40">
  <!-- <div class="mb-40">
    <app-attendees-banner></app-attendees-banner>
  </div> -->
  <div class="px-16">
    <app-page-title [text]="pageTitle"></app-page-title>
    <ng-content></ng-content>
  </div>
  <app-callout-signup></app-callout-signup>
  <app-callout-social></app-callout-social>
</main>
